import { useContext } from 'react';

import { Auth } from 'context';

const useAuth = () => useContext(Auth.Context);

export default useAuth;
